import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Transfer, Tooltip, Button } from "antd";
import FeatherIcon from 'feather-icons-react';

const OldSheetSettings = ({
  isProf,
  customColumnLabel,
  setCustomColumnLabel,
  defaultValues,
  setDefaultValues,
  targetKeys,
  setTargetKeys,
  filterOption,
  handleSearch,
  moveRow,
  translate,
  columnName,
  setColumnName,
  isComparison,
  saveSheetPreferences,
  sheets,
  setDefaultSheetPreference,
  deleteSetting,
  onChange,
  DraggableItem
}) => {
  return (
    <div
    className={`transfer__body ${!isProf && " hidden"}`}
  >
    <div className="left__arre">
      <div className="transfer__header">
        <div className="rght__tr_hh">
          <div className="new_ampt_colmn">
            <input
              type="text"
              className="field__input"
              value={customColumnLabel}
              placeholder={translate("Column name..")}
              onChange={(e) =>
                setCustomColumnLabel(e.target.value)
              }
            ></input>
            <Tooltip
              title={translate("Add New Custom Column")}
              placement="right"
            >
              <button
                onClick={() => {
                  if (customColumnLabel) {
                    let buffer = defaultValues;

                    setDefaultValues([
                      {
                        key: buffer.length,
                        title: customColumnLabel,
                      },
                      ...buffer,
                    ]);

                    setCustomColumnLabel("");
                  }
                }}
                className="button-stroke button-small activity__button js-activity-button cc link"
              >
                <FeatherIcon icon={"plus"} />
              </button>
            </Tooltip>
          </div>
          <h5 style={{ width: "100%" }}>
            1. {translate("Available Columns")}
          </h5>
        </div>

        <span className="mdividr"></span>

        <h5>2. {translate("Selected Columns")}</h5>
      </div>
      <DndProvider backend={HTML5Backend}>
        <Transfer
          rowKey={(record) => record.key}
          listStyle={{ flex: 1 }}
          dataSource={defaultValues}
          showSearch
          filterOption={filterOption}
          onSearch={handleSearch}
          render={(it) => (
            <DraggableItem
              index={targetKeys.findIndex(
                (key) => key === it.key
              )}
              label={it.title}
              moveRow={moveRow}
            />
          )}
          titles={[
            translate("Available"),
            translate("Selected"),
          ]}
          targetKeys={targetKeys}
          onChange={onChange}
        />
      </DndProvider>
    </div>

    <div className="right__arre">
      <div className="rght__tr_hh">
        <div className="new_ampt_colmn">
          <input
            type="text"
            className="field__input"
            value={columnName}
            onChange={(e) =>
              setColumnName(e.target.value)
            }
            placeholder={translate("Setting name..")}
          ></input>
          <Tooltip
            title={translate("Add New Setting")}
            placement="right"
          >
            <button
              onClick={() => {
                saveSheetPreferences(
                  columnName,
                  isComparison,
                  defaultValues
                    .map((i) => {
                      if (targetKeys.includes(i.key)) {
                        return {
                          column: i.title,
                          index: targetKeys.indexOf(
                            i.key
                          ),
                        };
                      }
                    })
                    .filter((i) => i)
                );
              }}
              className="button-stroke button-small activity__button js-activity-button cc link"
            >
              <FeatherIcon icon={"save"} />
            </button>
          </Tooltip>
        </div>
        <h5>3. {translate("Save Settings")}</h5>
      </div>

      <ul className="saved__Settingss">
        {sheets
          ?.filter(
            (i) => i.is_comparison === isComparison
          )
          .map((item) => {
            return (
              <li
                onClick={() =>
                  setDefaultSheetPreference(item.id)
                }
                className={`saved_setting_itm ${
                  item?.is_default ? "active" : ""
                }`}
              >
                <div className="saved_setting_title">
                  {item.preference_name}
                </div>
                <div className="saved_setting_actions">
                  <div className="d_flex_center">
                    <Tooltip
                      title={translate("Delete")}
                      placement="top"
                    >
                      <Button
                        onClick={() =>
                          deleteSetting(item.id)
                        }
                        icon={
                          <FeatherIcon icon={"trash"} />
                        }
                        className={"table_icon"}
                      />
                    </Tooltip>
                  </div>
                </div>
              </li>
            );
          })}
      </ul>
    </div>
  </div>
  );
};

export default OldSheetSettings;
